<template>
  <div>
    <div class="position-relative">
      
    
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">
                  Hide your API key from GitHub/GitLab/BitBucket 
                </h1>
                <p class="lead text-white">
                  <b-avatar
                    src="/img/andreas_braumann.png"
                    width="100"
                  ></b-avatar>
                  <small class="ml-3"
                    >Andreas Braumann · 10 min read</small
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->

    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md">
            <div class="pl-md-5">

              <h3>API keys and other credentials are a big problem on online git repos</h3>
              <p class="lead">
                Especially for public repositories it is crucial to not expose your credentials publically. If you don't take care it is very easy to accidentally add your API key inside your source code while testing. There are numerous bots that inspect every push instantly for credentials and try to use them automatically costing you lots of money.
              </p>
              <p>If you already pushed sensitive data follow these steps immediately:</p>
              <ol>
                <li>Revoke your credential or API key immediately and re-issue it</li>
                <li>Purge the file with sensitive data from your repository by reading this guide: <a href="https://docs.github.com/en/github/authenticating-to-github/removing-sensitive-data-from-a-repository" target="_blank">Removing sensitive data from a repository</a></li>
              </ol>

              <h3>There are proven ways for avoiding this situation</h3>
              <p>When creating a new project immediately use environment variables to set your credentials. Typically you place a file called <code>.env</code> inside the root of your project that has the following format:</p>
              <p><code>.env</code><br/>
              <code>SECRET_API_KEY=2NMi7dVjT3Ep9SPgWjRGsoIpz</code>
              </p>

              <TabsSection></TabsSection>

              <p>We provide code samples for the most common use cases</p>
              * node.js
              * Python
              * Ruby
              * PHP
              * Java
              * .NET
              * Swift
              * Objective-C
              * Go



              <p>To hide your API key in your production system you typically configure the environment variables with your app host. Here are the most common ways to set your environment variables:</p>
              * Heroku
              * AWS Lambda
              * Microsoft Azure Functions
              * Google Cloud Functions
              * Heroku

              However, there are some API keys that need to be used in calls from your front end. They cannot be hidden with environment variables as they have to be provided to the browser of your users. This is where hideAPIkey.com comes into play. We store your API key and provide you with a secure relay service that you can call without credentials. You can try it out directly here free for 24 hours and you can always delete your data immediately.


            </div>
          </div>
        </div>
      </div>
    </section>

    
    <section class="section section-lg pt-0">
      <div class="container">
        <card gradient="secondary" no-body shadow-size="lg" class="border-0">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <h3>Try hideAPIkey.com free for 24 hours*</h3>
                <hide-api-key-widget></hide-api-key-widget>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    </div>
  </div>
</template>
<script>
import HideApiKeyWidget from "../components/HideApiKeyWidget.vue";
import attachBanner from "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/esm/bundle.js";
import { BAvatar } from "bootstrap-vue/esm/components/avatar/avatar";
import TabsSection from "./TabsSection";

export default {
  name: "home",
  components: {
    HideApiKeyWidget,
    BAvatar,
    TabsSection,
  },
  mounted() {
    const options = {
      /**
       * You must set the cookie name.
       **/
      cookieName: "hideapikey_gdpr",

      /**
       * The cookie configuration, such as domain and path.
       **/
      cookieConfig: {
        domain: "hideapikey.com",
        path: "/",
      },

      /**
       * These are the top two lines of text on the banner
       * The 'description' field can include html such as links
       **/
      heading: "GDPR Notice",
      description:
        'We use cookies to offer a better browsing experience, analyze site traffic, personalize content, and serve targeted advertisements. Please review our <a href="/privacy-policy">privacy policy page</a>. By clicking accept, you consent to our privacy policy & use of cookies.',

      /**
       * All the button labels
       **/
      acceptLabel: "Accept",
      settingsLabel: "Preferences",
      closeLabel: "Close window",

      /**
       * These are the default opt-ins and their descriptions.
       * When value is set to true, the option will automatically be checked on load.
       *
       * If you don't want to show a category, simply remove the specified key from this object.
       **/
      choices: {
        necessary: {
          label: "Required cookies",
          description:
            "These can't be turned off as they are used to control all the other cookies",
          value: true,
        },
        analytics: false,
      },

      /**
       * Show an icon to edit cookies later, when banner is closed.
       **/
      showEditIcon: true,

      /**
       * These are the functions which are run if a user opts-in to that category.
       * You should drop your cookies here (or set a variable to control the later dropping of cookies.
       *
       * If you are using svelte, you can use events instead - see the Svelte section below.
       **/
      categories: {
        tracking: function () {
          let themejs = document.createElement("script");
          themejs.setAttribute(
            "src",
            "https://www.googletagmanager.com/gtag/js?id=G-Z1K6RVY03J"
          );
          document.head.appendChild(themejs);

          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag("js", new Date());

          gtag("config", "G-Z1K6RVY03J");
        },
        marketing: function () {},
        necessary: function () {},
      },
    };
    attachBanner(this.$refs.gdprBanner, options);
  },
};
</script>
<style scoped>
@import "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/style.css";
</style>